export const UPSERT_PACKAGE_INSTALLER = "UPSERT_PACKAGE_INSTALLER"
export const UPSERT_PACKAGE_INSTALLER_SUCCESS = "UPSERT_PACKAGE_INSTALLER_SUCCESS"
export const UPSERT_PACKAGE_INSTALLER_FAIL = "UPSERT_PACKAGE_INSTALLER_FAIL"

export const GET_LIST_PACKAGE_INSTALLER = "GET_LIST_PACKAGE_INSTALLER"
export const GET_LIST_PACKAGE_INSTALLER_SUCCESS = "GET_LIST_PACKAGE_INSTALLER_SUCCESS"
export const GET_LIST_PACKAGE_INSTALLER_FAIL = "GET_LIST_PACKAGE_INSTALLER_FAIL"

export const INACTIVE_PACKAGE_INSTALLER = "INACTIVE_PACKAGE_INSTALLER"
export const INACTIVE_PACKAGE_INSTALLER_SUCCESS = "INACTIVE_PACKAGE_INSTALLER_SUCCESS"
export const INACTIVE_PACKAGE_INSTALLER_FAIL = "INACTIVE_PACKAGE_INSTALLER_FAIL"

export const FILTER_PACKAGE_INSTALLER = "FILTER_PACKAGE_INSTALLER"
export const FILTER_LOADING_PACKAGE_INSTALLER = "FILTER_LOADING_PACKAGE_INSTALLER"

export const RESET_PACKAGE_INSTALLER_FLAG = "RESET_PACKAGE_INSTALLER_FLAG"
